var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPassed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00027 14.942C11.8341 14.942 14.942 11.8341 14.942 8.00027C14.942 4.16649 11.8341 1.05859 8.00027 1.05859C4.16649 1.05859 1.05859 4.16649 1.05859 8.00027C1.05859 11.8341 4.16649 14.942 8.00027 14.942ZM11.5772 6.12211C11.7725 5.92685 11.7725 5.61026 11.5772 5.415C11.382 5.21974 11.0654 5.21974 10.8701 5.415L6.76117 9.52396L5.13139 7.89417C4.93612 7.69891 4.61954 7.69891 4.42428 7.89417C4.22902 8.08943 4.22902 8.40602 4.42428 8.60128L6.40762 10.5846C6.60288 10.7799 6.91946 10.7799 7.11472 10.5846L11.5772 6.12211Z",
    fill: "#3CBA00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassed);
export default __webpack_public_path__ + "static/media/passed.28101df8.svg";
export { ForwardRef as ReactComponent };